<template>
  <mdb-container fluid>
    
    <section class="section">
      <div class="row">
        
        <div class="col-lg-4 mb-4">
          <!--Card-->
          <div class="card card-cascade narrower">
            <!--Card image-->
            <div
              class="view view-cascade gradient-card-header mdb-color lighten-3"
            >
              <h5 class="mb-0 font-weight-bold">ویرایش آواتار</h5>
            </div>
            
            <div class="card-body card-body-cascade text-center">
              <img
                :src="Avatar"
                :alt="FullName"
                class="z-depth-1 mb-3 mx-auto avatar"
              />
              <div>
                <mdb-file-input
                  textFieldTitle="انتخاب اواتر"
                  btnColor="primary"
                  btnTitle="انتخاب"
                  :img="true"
                  :src="file"
                  @getValue="saveImage"
                  v-show="showPanelUpload"
                ></mdb-file-input>
                <br>
              </div>

              <p class="text-muted">
                <small v-text="form.FirstName + ' ' + form.LastName"></small><br>
                <small v-html="form.Bio"></small>
              </p>
              <div class="row flex-center">
                <mdb-btn v-show="!showPanelUpload"
                  @click="showUpload"
                  color="info" 
                  rounded size="sm"
                  >ویرایش </mdb-btn
                >
                <mdb-btn v-show="showPanelUpload"
                  @click="uploadAvatar"
                  color="info" 
                  rounded size="sm"
                  >آپلود </mdb-btn
                >
              </div>
            </div>
            <!-- /.Card content -->
          </div>
          <!--/.Card-->
        </div>
        
        
        <div class="col-lg-8 mb-4">
          <div class="card card-cascade narrower">
            
            <div
              class="view view-cascade gradient-card-header mdb-color lighten-3"
            >
              <h5 class="mb-0 font-weight-bold">ویرایش پروفایل</h5>
            </div>
            
            <div class="card-body card-body-cascade text-center">
              
              <ValidationObserver v-slot="{ invalid }">
                <div class="row">
                  <!--Second column-->
                  <div class="col-md-6">
                    <mdb-input label="نام کاربر" 
                      :readOnly="true"
                      v-model="form.UserName" />
                  </div>
                  <!--First column-->
                  <div class="col-md-6">
                    <ValidationProvider v-slot="{ errors }" name="Organization" rules="required">
                    <mdb-input label="ارگان یا سازمان و شرکتس"
                      class="rtl"
                      v-model="form.Organization" />
                    </ValidationProvider>
                  </div>
                </div>
                
                <div class="row">
                  <!--First column-->
                  <div class="col-md-6">
                    <ValidationProvider v-slot="{ errors }" name="FirstName" rules="required">
                      <mdb-input
                      v-model="form.FirstName"
                      class="rtl"
                      label="نام" />
                    </ValidationProvider>

                  </div>
                  <!--Second column-->
                  <div class="col-md-6">
                    <ValidationProvider v-slot="{ errors }" name="LastName" rules="required">
                      <mdb-input
                      v-model="form.LastName"
                      class="rtl"
                      label="نام خانوادگی" />
                    </ValidationProvider>
                    
                  </div>
                    
                </div>
                
                <div class="row">
                  <!--Second column-->
                  <div class="col-md-6">
                    <mdb-input 
                      v-model="form.Mobile"
                      :readOnly="true"
                      label="شماره موبایل" />
                  </div>
                  <!--First column-->
                  <div class="col-md-6">
                    <mdb-input 
                      v-model="form.Email"
                      :readOnly="true"
                      label="ایمیل" />
                    
                  </div>
                </div>
                
                <div class="row">
                  <!--Second column-->
                  <div class="col-md-6">
                    <ValidationProvider v-slot="{ errors }" name="Phone" rules="required">
                      
                    <mdb-input 
                      v-model="form.Phone"
                      label="شماره تلفن" />
                    </ValidationProvider>
                  </div>
                  <!--First column-->
                  <div class="col-md-6">
                    <ValidationProvider v-slot="{ errors }" name="CodePostal" rules="required">
                      <mdb-input 
                      v-model="form.CodePostal"
                      label="کدپستی" />
                    </ValidationProvider>
                    
                  </div>
                </div>

                <div class="row">
                  <!--Second column-->
                  <div class="col-md-6">
                    <ValidationProvider v-slot="{ errors }" name="Side" rules="required">
                      <mdb-input 
                      v-model="form.Side"
                      class="rtl"
                      label="سمت" />
                    </ValidationProvider>
                    
                  </div>
                  <!--First column-->
                  <div class="col-md-6">
                    
                      <div class="md-form">
                        <label class="active mr-5">تاریخ تولد</label>
                    <ValidationProvider v-slot="{ errors }" name="BirthDate" rules="required">
                      
                        <date-picker v-model="form.BirthDate"></date-picker>
                    </ValidationProvider>
                      </div>
                  </div>
                </div>

                
                <div class="row">
                  <div class="col-md-6">
                    <ValidationProvider v-slot="{ errors }" name="City" rules="required">
                      <mdb-select
                        search
                        label="لطفا استان خودتان را انتخاب کنید"
                        :options="getProvince"
                        searchPlaceholder="جستجو"
                        :required="true"
                        @change="selectProvince"
                      />
                    </ValidationProvider>
                   
                    
                  </div>
                  <!--First column-->
                  <div class="col-md-6">
                     <ValidationProvider v-slot="{ errors }" name="Province" rules="required">
                      
                      
                      <!-- @getValue="getSelectValue" -->
                    <mdb-select
                      search
                      label="لطفا شهر خودتان را انتخاب کنید"
                      :options="getCity"
                      searchPlaceholder="جستجو"
                      :required="true"
                      @change="selectCity"
                    />
                    </ValidationProvider>
                    
                  </div>
                </div>
                

                <div class="row">
                  <div class="col-md-6">
                    <ValidationProvider v-slot="{ errors }" name="Bio" rules="required">
                      <mdb-textarea 
                      v-model="form.Bio"
                      class="rtl"
                      label="بیو" :rows="3" />
                    </ValidationProvider>
                    
                  </div>
                  <!--First column-->
                  <div class="col-md-6">
                    <ValidationProvider v-slot="{ errors }" name="Address" rules="required">
                      <mdb-textarea 
                      v-model="form.Address"
                      class="rtl"
                      label="ادرس" :rows="3" />
                    </ValidationProvider>
                    
                  </div>
                </div>

                
                <div class="row">
                  
                  <div v-show="message!==null" class="alert alert-danger" v-html="message">
                  </div>
                  <div class="col-md-12 text-center my-4">
                      <input
                      :disabled="invalid || posting" 
                      :loading="posting"
                      @click="confirm" 
                      type="submit"
                      value="بروز رسانی"
                      class="btn btn-info btn-rounded"
                    />
                    
                    
                  </div>
                </div>
                
              </ValidationObserver>
            </div>
          </div>

          <br />

          <div v-for="company in companies" :key="company.CompanyId">
            <company :company="company" />
          </div>

        </div>

      </div>
    </section>
  </mdb-container>
</template>

<script>
import accountApi from "@/api/accountApi";
import systemApi from "@/api/systemApi";
import uploadApi from "@/api/uploadApi";
import companyApi from "@/api/companyApi";
import { mdbContainer, mdbBtn, mdbInput, mdbTextarea, mdbFileInput,
  mdbSelect, } from "mdbvue";

import { actionTypes, commitTypes, dbName, commit } from "@/store-types";
import company from "@/components/custom/Company";

export default {
  name: "UserProfile",
  components: {
    mdbContainer,
    mdbBtn,
    mdbInput,
    mdbTextarea,
    mdbFileInput,
    mdbSelect,
    company,
  },
  data() {
    return {
      posting: false,
      form: {
        BirthDate: null,
        Mobile: null,
        Email: null,
        UserName: null,
        FirstName: null,
        LastName: null,
        Profit: 0,
        Address: null,
        Avatar: null,
        Bio: null,
        CodePostal: null,
        NationalCodeConfirmed: false,
        Organization: null,
        Phone: null,
        Side: null,
        TelPhoneConfirmed: false,
      },
      message: null,
      showPanelUpload: false,
      file: null,
      Avatar: null,
      FullName: null,
      companies: null,
      province: null,
    };
  },
  methods:{
    saveImage(files) {
      this.file = files[0];
    },
    showUpload(){
      this.showPanelUpload = !this.showPanelUpload;
    },
    uploadAvatar(){
      let formData = new FormData();
      formData.append('file', this.file);

      uploadApi
        .uploadAvatar(formData)
        .then(({ data }) => {
          if (data.Status === 1) {
            this.posting = false;
            this.$toastr.s("پروفایل", "آواتار با موفقیت بروز رسانی شد.");

            // this.$router.push({name: "Home"});
            this.$store.dispatch(actionTypes.SAVE_DATA);
          } else {
            this.message = data.Message;
            this.posting = false;
            console.log(data);
            this.$toastr.e("پروفایل", data.Message);
            
          }
        },
        (r) => {

          var message = r.response.data.errors;
          this.posting = false;
          this.message = null;

          if(message.hasOwnProperty("file")){
            this.message = message.CaptchaInputText;
          }

          
          this.$toastr.e("پروفایل", "خطا در اپلود لطفا فایل مناسب انتخاب کنید");
        }
      );

      this.showPanelUpload = false;
    },
    confirm() {

      accountApi.updateUserProfile(this.form).then(
        ({ data }) => {
          if (data.Status === 1) {
            this.posting = false;          
            this.$store.state.userProfile.Avatar = data.Data;
            this.$toastr.s("پروفایل", "پروفایل با موفقیت بروز رسانی شد.");  
            this.$router.push({name: "Home"});
            this.$store.state.user.FullName = this.$store.state.userProfile.FirstName
                +' '+this.$store.state.userProfile.LastName;
          } else {
            this.message = data.Message;
            this.posting = false;
            this.$toastr.e("پروفایل", data.Message); 
          }
        },
        (r) => {

          var message = r.response.data.errors;
          this.posting = false;
          this.message = null;

          if(message.hasOwnProperty("CaptchaInputText")){
            this.message = message.CaptchaInputText;
          }

          if(message.hasOwnProperty("BirthDate")){
            this.message = message.BirthDate;
          }

          if(message.hasOwnProperty("FirstName")){
            this.message = message.FirstName;
          }

          if(message.hasOwnProperty("LastName")){
            this.message = message.LastName;
          }

          if(message.hasOwnProperty("CodePostal")){
            this.message = message.CodePostal;
          }

          if(message.hasOwnProperty("Bio")){
            this.message = message.Bio;
          }
          
          if(message.hasOwnProperty("Address")){
            this.message = message.Address;
          }

          if(message.hasOwnProperty("Organization")){
            this.message = message.Organization;
          }
          
          if(message.hasOwnProperty("Phone")){
            this.message = message.Phone;
          }

          if(message.hasOwnProperty("Side")){
            this.message = message.Side;
          }
          
        }
      );
    },
    selectProvince(value){
      if(value == null) return;
      console.log("select Province",value);
      this.form.ProvinceId = value;
    },
    selectCity(value,text){
      if(value == null) return;
      console.log("select City",value,text);
      this.form.CityId = value;
    },
  },
  computed: {
    //ProvinceId
    getProvince: function() {
        if (this.province == null || !this.province)
          return [{ value: 0,text: 'درحال بارگذاری'}];
        console.log("getProvince");
        let thisVue = this;
        return this.province.map(
          function(item){
              return { value: item.ProvinceId, text: item.Name, selected: thisVue.form.ProvinceId == item.ProvinceId };
          }
        );
      },
    getCity: function() {
        if (this.province == null || !this.province)
          return [{ value: 0,text: 'درحال بارگذاری'}];
        console.log("getCity");
        let thisVue = this;
        let province = this.province.find(option => {
          return option.ProvinceId === thisVue.form.ProvinceId;
        });

        if (province == null){          
          console.log("getCity provinceid : "+thisVue.form.ProvinceId);
          return [];
        }

        return province.Cities.map(
          function(item){
            // console.log( item,thisVue.form);
            return { value: item.CityId, text: item.Name, selected: thisVue.form.CityId == item.CityId };
          }
        );
      },
    
  },
  mounted() {

    if(this.$store.state.userProfile.FirstName == null)
    {
      accountApi
        .userProfile()
        .then(({ data }) => {
          
          this.$store.state.userProfile = data;
          this.form = this.$store.state.userProfile;
          this.Avatar = this.$store.state.config.MainDomain + ''+ this.$store.state.userProfile.Avatar;
          this.FullName = this.$store.state.userProfile.FirstName+' '+this.$store.state.userProfile.LastName;

          this.$store.dispatch(actionTypes.SAVE_DATA);
        }).catch((e) => {
            console.log("error load user profile");
        });
    }else{
      this.form = this.$store.state.userProfile;
      this.Avatar = this.$store.state.config.MainDomain + ''+ this.$store.state.userProfile.Avatar;
      this.FullName = this.$store.state.userProfile.FirstName+' '+this.$store.state.userProfile.LastName;
    }

    this.province = this.$store.state.province;
    if(this.province == null || this.province == []) {
      systemApi.getProvince().then(
        ({ data }) => {
          // console.log(data);
          // this.province = data;
          this.$store.state.province = data;
          this.province = this.$store.state.province;
        },
        (r) => {

        }
      );
    }

    this.companies = this.$store.state.companies;
    companyApi.getCompany().then(
        ({ data }) => {
          // console.log(data);
          // this.companies = data;
          this.$store.state.companies = data;
          this.companies = this.$store.state.companies;
        },
        (r) => {

        }
      );
  },
  // watch:{
  //   getProvince: function() {
  //     console.log('province');
  //   }
  // }
  // components: {
  //   datePicker: VuePersianDatetimePicker
  // }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.card.card-cascade .view.gradient-card-header {
  padding: 1.1rem 1rem;
}

.card.card-cascade .view {
  box-shadow: 0 5px 12px 0 rgba(0, 0, 0, 0.2), 0 2px 8px 0 rgba(0, 0, 0, 0.19);
}

.card.card-cascade.narrower .view.view-cascade {
  margin-top: -1.25rem;
  margin-right: 4%;
  margin-left: 4%;
}
</style>
